export default __webpack_public_path__ + "static/varios-digital-internacional-6ffb02c78c3bd6fa9d2cad9c7fd8e6c9.jpg";